// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { autoCompleteSharedStyles } from "@guestsupply/App/WidgetExtensions/Header/SearchInputExtensions";
import {
    autocompleteCategoriesStyles,
    AutocompleteCategoriesStyles,
} from "@guestsupply/Overrides/Widgets/Header/AutocompleteCategories";
import { color, mergeWithCss } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

const autocompleteCategoriesStylesExtensions: AutocompleteCategoriesStyles = {
    headerText: {
        ...autoCompleteSharedStyles?.headerText,
    },
    subHeaderText: {
        weight: 600,
        css: css`
            text-align: left;
            margin: 0 0 5px 0;
        `,
    },
    divider: {
        css: css`
            min-width: 100%;
        `,
    },
    autocompleteCategoriesRowWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    autocompleteCategoriesColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 375px;
        `,
    },
    link: {
        ...autoCompleteSharedStyles?.link,
    },
    focusedCategoryItemText: {
        ...mergeWithCss(autoCompleteSharedStyles?.focusedItemText, {
            css: css`
                display: flex;
                flex-direction: column;
                background: ${color("common.ui3")};
            `,
        }),
    },
    focusedLink: {
        ...mergeWithCss(autoCompleteSharedStyles.focusedLink, {
            typographyProps: {
                weight: "bold",
            },
        }),
    },
    categoryItemText: {
        ...mergeWithCss(autoCompleteSharedStyles?.itemText, {
            css: css`
                display: flex;
                flex-direction: column;
            `,
        }),
    },
};

autocompleteCategoriesStyles.headerText = autocompleteCategoriesStylesExtensions.headerText;
autocompleteCategoriesStyles.link = autocompleteCategoriesStylesExtensions.link;
autocompleteCategoriesStyles.focusedCategoryItemText = autocompleteCategoriesStylesExtensions.focusedCategoryItemText;
autocompleteCategoriesStyles.focusedLink = autocompleteCategoriesStylesExtensions.focusedLink;
autocompleteCategoriesStyles.categoryItemText = autocompleteCategoriesStylesExtensions.categoryItemText;
